import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "geo-item-search junkai-tenken-report-tenken-data" }
const _hoisted_2 = { class: "tenken-kubun" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = ["for"]
const _hoisted_6 = {
  key: 0,
  class: "hantei"
}
const _hoisted_7 = ["id", "value"]
const _hoisted_8 = ["for"]

import {
  onMounted,
  reactive,
  ref,
} from 'vue';
import type { JunkaiTenkenIndexParams } from 'src/models/apis/extJunkaiTenkenReportTenkenData/extJunkaiTenkenReportTenkenDataRequest';
import GeoItemSearchCommon from 'src/components/Top/geoItemSearchComponents/GeoItemSearchCommon.vue';
import type { CommonSearchParams } from 'src/models/geoItemSearch';
import extJunkaiTenkenReportTenkenDataApi from 'src/apis/extJunkaiTenkenReportTenkenData';
import type {
  TenkenKubun,
  Hantei,
} from 'src/models/extJunkaiTenkenReportTenkenData';

interface SearchParams {
  tenkenKubuns: TenkenKubun[];
  hanteis: Hantei[];
}

interface GeoItemSearchJunkaiTenkenReportTenkenDataState {
  search: SearchParams;
  showTenkenKubun: boolean;
  showGroupedTenkenKubuns: Record<string, boolean>;
  groupedTenkenKubuns: Record<string, TenkenKubun[]>;
  showHantei: boolean;
  hanteis: Hantei[];
}

const checkboxKeyPrefix = 'tenken';


export default /*@__PURE__*/_defineComponent({
  __name: 'GeoItemSearchJunkaiTenkenReportTenkenData',
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const initSearchState = (): SearchParams => {
  return {
    tenkenKubuns: [],
    hanteis: [],
  };
};
const state = reactive<GeoItemSearchJunkaiTenkenReportTenkenDataState>({
  search: initSearchState(),
  showTenkenKubun: false,
  showGroupedTenkenKubuns: {},
  groupedTenkenKubuns: {},
  showHantei: false,
  hanteis: [],
});
const getGroupedTenkenKubuns = (tenkenKubuns: TenkenKubun[]): Record<string, TenkenKubun[]> => {
  // 点検区分一覧データを「路上・土木」、「路上・施設」、「路下・土木」、「路下・施設」、「高架下」...ごとにグループ化する
  const results = Object.values(tenkenKubuns)
    .reduce((acc: Record<string, TenkenKubun[]>, tenkenKubun) => {
      const baseName = tenkenKubun.tenkengyomuBaseName.replace(/巡回点検$/, '');
      const detailName = tenkenKubun.tenkengyomuDetailName.replace(/電気関係$|関係$/, '');
      const key = (baseName === detailName) ? baseName : `${baseName}・${detailName}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(tenkenKubun);
      return acc;
    }, {});

  return results;
};

onMounted(async() => {
  try {
    const masterData = await extJunkaiTenkenReportTenkenDataApi.getTenkenMaster();
    state.groupedTenkenKubuns = getGroupedTenkenKubuns(masterData.tenkenKubuns);
    state.showGroupedTenkenKubuns = Object.keys(state.groupedTenkenKubuns)
      .reduce((acc: Record<string, boolean>, key) => {
        acc[key] = false;
        return acc;
      }, {});
    state.hanteis = masterData.hanteis;
  } catch {
    // マスターデータ取得失敗時は検索条件を空のまま表示する（致命的ではないため画面はブロックしない）
  }
});

const commonSearchParams = ref<CommonSearchParams | null>(null);
const getSearchParams = (): JunkaiTenkenIndexParams | null => {
  if (!commonSearchParams.value) return null;

  const { tsFrom: dtFrom, tsTo: dtTo, ...other } = commonSearchParams.value;
  return {
    dt_from: dtFrom,
    dt_to: dtTo,
    road_names: other.roadNameDisps,
    directions: other.directions,
    tenken_kubuns: state.search.tenkenKubuns.map(e => e.id),
    hanteis: state.search.hanteis.map(e => e.id),
  };
};
const onChange = () => {
  emit('change');
};

__expose({ getSearchParams });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GeoItemSearchCommon, {
      "search-params": commonSearchParams.value,
      "onUpdate:searchParams": _cache[0] || (_cache[0] = ($event: any) => ((commonSearchParams).value = $event)),
      "checkbox-key-prefix": checkboxKeyPrefix,
      "is-kp-search": false,
      "default-days-before": 7,
      onChange: onChange
    }, null, 8, ["search-params"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "title-area",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (state.showTenkenKubun = !state.showTenkenKubun))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fas mr4", {
          'fa-caret-right': !state.showTenkenKubun,
          'fa-caret-down': state.showTenkenKubun,
        }])
        }, null, 2),
        _cache[5] || (_cache[5] = _createTextVNode(" 点検区分 ", -1))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(state.groupedTenkenKubuns), (key) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: key,
          class: "ml12"
        }, [
          _createElementVNode("span", {
            class: "title-area",
            onClick: ($event: any) => (state.showGroupedTenkenKubuns[key] = !state.showGroupedTenkenKubuns[key])
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas mr4", {
            'fa-caret-right': !state.showGroupedTenkenKubuns[key],
            'fa-caret-down': state.showGroupedTenkenKubuns[key],
          }])
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(key), 1)
          ], 8, _hoisted_3),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.groupedTenkenKubuns[key], (tenkenKubun, tenkenKubun_idx) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "custom-control custom-checkbox ml15",
              key: tenkenKubun_idx
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "custom-control-input",
                id: `${checkboxKeyPrefix}-${key}-${tenkenKubun_idx}`,
                value: tenkenKubun,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.search.tenkenKubuns) = $event)),
                onChange: onChange
              }, null, 40, _hoisted_4), [
                [_vModelCheckbox, state.search.tenkenKubuns]
              ]),
              _createElementVNode("label", {
                class: "custom-control-label",
                for: `${checkboxKeyPrefix}-${key}-${tenkenKubun_idx}`
              }, _toDisplayString(tenkenKubun.tenkenKubunName), 9, _hoisted_5)
            ])), [
              [_vShow, state.showGroupedTenkenKubuns[key]]
            ])
          }), 128))
        ])), [
          [_vShow, state.showTenkenKubun]
        ])
      }), 128))
    ]),
    (state.hanteis.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("span", {
            class: "title-area",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (state.showHantei = !state.showHantei))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas mr4", {
          'fa-caret-right': !state.showHantei,
          'fa-caret-down': state.showHantei,
        }])
            }, null, 2),
            _cache[6] || (_cache[6] = _createTextVNode(" 判定 ", -1))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.hanteis, (e) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "custom-control custom-checkbox ml15",
              key: e.id
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "custom-control-input",
                id: `${checkboxKeyPrefix}-hantei-${e.id}`,
                value: e,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.search.hanteis) = $event)),
                onChange: onChange
              }, null, 40, _hoisted_7), [
                [_vModelCheckbox, state.search.hanteis]
              ]),
              _createElementVNode("label", {
                class: "custom-control-label",
                for: `${checkboxKeyPrefix}-hantei-${e.id}`
              }, _toDisplayString(e.hantei), 9, _hoisted_8)
            ])), [
              [_vShow, state.showHantei]
            ])
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})